exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-root {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: absolute;\n  top: 56px;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\napp-navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2; }\n\napp-root > app-homepage {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n@media (max-width: 720px) {\n  app-root {\n    top: 92px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main